import { ReactNode } from "react";

import { CircleDisabledIcon, PersonJoinedIcon, PersonSingleIcon } from "mds/icons";
import { SectionUserActivityStatus, UserWithSectionActivity } from "store/selectors";

export const userActivityIcons: Record<SectionUserActivityStatus | "disabled", ReactNode> = {
  active: <PersonJoinedIcon statusColor="green" />,
  inactive: <PersonJoinedIcon statusColor="green" />,
  offline: <PersonSingleIcon />,
  disabled: <CircleDisabledIcon />,
};

export const getActiveStateSortKeyForUser = (user: UserWithSectionActivity) => {
  return ["active", "inactive", "offline"].indexOf(user.sectionActivityStatus) > 1 ? 1 : 0;
};

export const isUserOnline = (status: SectionUserActivityStatus) =>
  status === SectionUserActivityStatus.ACTIVE || status === SectionUserActivityStatus.INACTIVE;
